import React, { useEffect, useState } from "react";
import { loadYaml } from "../utils/loadYaml";
import { FeatureGrid } from "../components/FeatureGrid";
import { ProductGrid } from "../components/productgrid";
import { BifurcatedPromo } from "../components/BifurcatedPromo";
import { TeamSection } from "../components/TeamSection";
import { AI } from "../components/AI"; 
import ClientImpactJourney from "../components/ClientImpactJourney";
import HomeHeroSlider from "../components/HomeHeroSlider";
import "./Company.css";

interface Section {
  type: string;
  id?: string;
  [key: string]: any;
}

interface SectionsData {
  sections: Section[];
}

export const Company: React.FC = () => {
  const [sections, setSections] = useState<Section[]>([]);
  const [loadError, setLoadError] = useState<string | null>(null);

  useEffect(() => {
    loadYaml("/config/company.yaml")
      .then((data: SectionsData | null) => {
        if (data?.sections) {
          setSections(data.sections);
        } else {
          setLoadError("Company content could not be loaded.");
        }
      })
      .catch(() => setLoadError("Company content could not be loaded."));
  }, []);

  if (!sections.length) {
    return <div className="page-loading">{loadError || "Loading company page..."}</div>;
  }

  return (
    <div className="stellar-home">
      <HomeHeroSlider />
      {sections.map((s, idx) => {
        switch (s.type) {
          case "hero":
            return null;

          case "featureGrid":
            return <FeatureGrid title={""} key={idx} {...s} features={s.features || []} id={s.id} />;

          case "productGrid":
            return <ProductGrid title={""} key={idx} {...s} products={s.products || []} id={s.id} />;

          case "bifurcatedPromo":
            if (s.id === "purpose") {
              return null;
            }
            if (s.id === "client-impact") {
              return <ClientImpactJourney key={idx} id={s.id} />;
            }
            return (
              <BifurcatedPromo
                title={""}
                key={idx}
                {...s}
                left={s.left || {}}
                right={s.right || {}}
                id={s.id}
              />
            );

          case "team":
            return <TeamSection title={""} key={idx} {...s} members={s.members || []} id={s.id} />;

          case "ai": 
            return <AI suggestions={[]} title={""} description={""} key={idx} {...s} id={s.id} />;

          default:
            return null;
        }
      })}
    </div>
  );
};

export default Company;
